<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <h1 class="titulo mb-3">Relatório de Auditoria</h1>
        <v-card class="card">
            <v-card-text>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition" color="primary" rounded @click="toggleFiltro">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="exportarExcel">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        SALVAR RELATÓRIO
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <div v-if="filter_open" class="pa-5">
                        <v-row>
                            <v-col cols="12" md="6">
                                <Autocomplete label="Usuários: "
                                              item-text="login"
                                              item-value="id_usuario"
                                              placeholder="Selecione os usuários"
                                              :items="usuarios"
                                              v-model="filtro.usuarios"
                                              multiple />
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <DateTimeRange v-model="filtro.data_hora" @filter="filtrar()" :shortcut="true" label="Data/hora" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select label="Funcionalidade: "
                                          placeholder="Selecione a funcionalidade"
                                          :items="funcionalidades"
                                          item-text="funcionalidade"
                                          item-value="funcionalidade"
                                          v-model="filtro.funcionalidade"
                                          outlined />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select label="Operação: "
                                          placeholder="Selecione a operação"
                                          :items="operacoes"
                                          item-text="operacao"
                                          item-value="operacao"
                                          v-model="filtro.operacao"
                                          outlined />
                            </v-col>
                        </v-row>
                        <v-row class="justify-space-between">
                            <v-btn color="secondary" class="mr-4" @click="limparFiltros">Limpar</v-btn>
                            <v-btn color="primary" @click="filtrar">Filtrar</v-btn>
                        </v-row>
                    </div>
                </collapse-transition>
                <DataTable :headers="headers"
                           :params="params"
                           :filter="datatable_filter"
                           overflow-y-visible
                           url="/painel/auditoria">
                    <template v-slot:items="{item}">
                        <td>{{ item.usuario.login }}</td>
                        <td>
                            <p class="ellipsis-text">{{ item.browser }}</p>
                            <span class="text-tooltip">{{ item.browser }}</span>
                        </td>
                        <td>{{ item.data_hora | toDateTimeBR }}</td>
                        <td>{{ item.funcionalidade }}</td>
                        <td>
                            <p class="ellipsis-text">{{ item.dados_new || 'N/A' }}</p>
                            <span v-if="item.dados_new" class="text-tooltip">{{ item.dados_new }}</span>
                        </td>
                        <td>
                            <p class="ellipsis-text">{{ item.dados_old || 'N/A' }}</p>
                            <span v-if="item.dados_old" class="text-tooltip">{{ item.dados_old }}</span>
                        </td>
                        <td>{{ item.operacao }}</td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import moment from 'moment'
  import Qs from 'qs'

  export default {
    name: 'Auditoria',
    data: () => ({
      filter_open: false,
      headers: [
        { text: 'Usuário', value: 'usuario' },
        { text: 'Navegador', value: 'browser' },
        { text: 'Data/hora', value: 'data_hora' },
        { text: 'Funcionalidade', value: 'funcionalidade' },
        { text: 'Vlr. novo', value: 'dados_new' },
        { text: 'Vlr. antigo', value: 'dados_old' },
        { text: 'Operação', value: 'operacao' }
      ],
      params: {
        pagination: {
          rowsPerPage: 15,
          items_grid: 15,
          sortBy: 'data_hora',
          descending: true
        },
        data_hora: ['', ''],
        funcionalidade: null,
        operacao: null
      },
      usuarios: [],
      funcionalidades: [],
      operacoes: [],
      filtro: {
        usuarios: [],
        data_hora: ['', ''],
        funcionalidade: 'TODOS',
        operacao: 'TODOS'
      },
      datatable_filter: {
        id_usuario: []
      }
    }),
    mounted () {
      this.carregarUsuarios()
      this.carregarFuncionalidades()
      this.carregarOperacoes()
    },
    methods: {
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      async carregarUsuarios () {
        try {
          const res = await this.$http.get('/painel/usuarios')
          this.usuarios = res.data
        } catch (e) {
          notification('error', e, 'Não foi possível buscar os usuários')
        }
      },
      async carregarFuncionalidades () {
        try {
          const res = await this.$http.get('/painel/auditoria/funcionalidades')
          this.funcionalidades = res.data
          this.funcionalidades.unshift('TODOS')
        } catch (e) {
          notification('error', e, 'Não foi possível buscar as funcionalidades')
        }
      },
      exportarExcel () {
        const filtros = { id_usuario: this.datatable_filter.id_usuario, data_hora: this.params.data_hora, funcionalidade: this.params.funcionalidade, operacao: this.params.operacao }

        const headersExport = this.headers
          .filter(h => h.value)
          .map(h => h.value)

        const headersFormatadoExport = this.headers
          .filter(h => h.value)
          .map(h => h.text)

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: 'data_hora', descending: true },
          headers: headersExport,
          headers_formatado: headersFormatadoExport
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/auditoria/exportar?${encoded_params}`)
        } catch (error) {
          notification('error', `${error.response?.data?.error || error.message}`)
        }
      },
      async carregarOperacoes () {
        try {
          const res = await this.$http.get('/painel/auditoria/operacoes')
          this.operacoes = res.data
          this.operacoes.unshift('TODOS')
        } catch (e) {
          notification('error', e, 'Não foi possível buscar as operações')
        }
      },
      filtrar () {
        this.datatable_filter = {
          id_usuario: this.filtro.usuarios
        }

        // Esse format serve para evitar problemas com UTC
        if (this.filtro.data_hora[0]) {
          this.params.data_hora[0] = moment(this.filtro.data_hora[0]).format('YYYY-MM-DD[T]HH:mm:ss')
        } else {
          this.params.data_hora[0] = null
        }
        if (this.filtro.data_hora[1]) {
          this.params.data_hora[1] = moment(this.filtro.data_hora[1]).format('YYYY-MM-DD[T]HH:mm:ss')
        } else {
          this.params.data_hora[1] = null
        }
        this.params.funcionalidade = this.filtro.funcionalidade
        this.params.operacao = this.filtro.operacao
      },
      limparFiltros () {
        this.filtro = {
          usuarios: [],
          data_hora: ['', ''],
          funcionalidade: 'TODOS',
          operacao: 'TODOS'
        }
        this.filtrar()
      }
    }
  }
</script>

<style lang="scss" scoped>
    td {
        position: relative;
    }
    .ellipsis-text {
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 0;
    }

    .ellipsis-text:hover + .text-tooltip, .text-tooltip:hover {
        z-index: 1;
        opacity: 1;
    }

    .text-tooltip {
        opacity: 0;
        position: absolute;
        top: 80%;
        left: 0;
        background: #FFF;
        padding: 5px;
        border: 2px solid var(--primary);
        border-radius: 5px;
        z-index: -1;
        transition: all ease 500ms;

        max-width: 200px;
        white-space: normal;
        word-wrap: break-word;

        &:after {
            width: 0;
            height: 0;
            position: absolute;
            left: 10px;
            bottom: 100%;
            content: '';
            border: 10px solid transparent;
            border-bottom-color: var(--primary);
        }
    }
</style>
